import { computed, ref } from '@vue/composition-api'
import { getPWADisplayMode, handleClickInstall, pwaIsInstalled } from '@/utils/pwainstaller'
import useForm from '@/compositions/useForm'
import useRequest from '@/compositions/useRequest'
import useSmsConfirmation from '@/compositions/useSmsConfirmation'

import { required } from '@/utils/validations'
import { isIOS } from '@/utils/iosDetector'

import PhoneNumber from '@/components/PhoneNumber/PhoneNumber'
import SmsConfirmationPopup from '@/components/SmsConfirmationPopup'

import Orders from '../Orders/Orders'

export default {
  components: {
    PhoneNumber,
    SmsConfirmationPopup,
    Orders,
  },
  setup(props, context) {
    const { refs } = context
    const { $store } = context.root
    const showSms = ref(false)

    const logged = computed(() => $store.state.driver.logged)

    const {
      validate, $errors, formData, getData,
    } = useForm({
      fields: {
        phone: { default: '', validations: { required } },
      },
    })

    const requestCodeRequest = useRequest({
      context,
      request: ({ phone }) => $store.dispatch('driver/requestCode', { phone }),
    })

    const { smsConfirmation, smsId, requestCode } = useSmsConfirmation({
      request: async () => requestCodeRequest.makeRequest(getData()),
    })

    const submitCodeRequest = async () => {
      if (showSms.value) {
        refs.smsConfirm.submit()
        return
      }
      if (!validate()) return
      await requestCode()
      showSms.value = true
    }

    const authByTokenRequest = useRequest({
      context,
      request: authDriverToken => $store.dispatch('driver/authByToken', authDriverToken),
    })

    const handleCodeSuccess = async ({ authDriverToken }) => {
      await authByTokenRequest.makeRequest(authDriverToken)
      smsConfirmation.value = false
      showSms.value = false
    }
    return {
      $errors,
      formData,
      smsId,
      smsConfirmation,
      pwaIsInstalled,
      handleClickInstall,
      getPWADisplayMode,
      loading: authByTokenRequest.loading,
      logged,
      showSms,
      isIOS,
      handleCodeSuccess,
      submitCodeRequest,
    }
  },
}
